import * as tg from "generic-type-guard";

export const isCustomProcessActivityData = new tg.IsInterface()
	.withOptionalProperty("showAssignmentModal", tg.isBoolean)
	.get();
